const uploadUrl = 'https://upload.wistia.com';

const uploadUrlWithAToken = 'https://upload.wistia.com?access_token=4ac2261a5cb64681e2254ddbd8287b3f2a37fc32f2d98c304fdc47afdcc89f56';

const projectId = (() => {
  if (process.env.MY_ENV === 'production' || process.env.MY_ENV === 'staging') {
    return 'uok8rx2esa';
  }
  return 'f14cbi208t';
})();

export default {
  uploadUrl,
  uploadUrlWithAToken,
  projectId
};
